import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'
import { BadgeProps, Carousel } from '@hhgtech/hhg-components/mantine'

export const EmotionBadge = {
  root: {
    background: '#ffffff',
    borderRadius: '32px',
    padding: '0',
    textTransform: 'unset',
    height: 'auto',
  },
} as BadgeProps['styles']

export const StyledPost = styled.div`
  .header {
    width: 100%;
    display: flex;
    gap: 16px;

    .detail {
      width: 100%;
      flex-grow: 1;
      gap: 4px;
      display: flex;
      flex-direction: column;
      &-author {
        display: flex;
        gap: 4px;
        align-items: center;
      }
      button {
        width: fit-content;
        text-align: left;
      }
    }
  }
  .content {
    margin-top: 8px;
    margin-bottom: 16px;
    a {
      color: ${theme?.colors.primaryBase};
      text-decoration: underline;
    }
    mention {
      color: ${theme?.colors.primaryBase};
      padding-right: 4px;
      &:first-of-type ~ * {
        &:not(ul),
        &:not(ol) {
          display: inline-block;
        }
      }
      &:first-of-type {
        margin-right: 5px;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .action {
    display: flex;
    gap: 24px;
    align-items: center;
    justify-content: end;
    > * {
      display: flex;
      gap: 8px;
      align-items: center;
      justify-content: end;
    }
  }
`

export const StyledCarousel = styled(Carousel)`
  cursor: grab;
  ${MediaQueries.mbDown} {
    width: 100%;
  }
  .mantine-Carousel-control {
    &[data-inactive] {
      opacity: 0;
      cursor: default;
    }
    background-color: #ffffff;
    opacity: 1;
    ${MediaQueries.mbUp} {
      &:first-of-type {
        transform: translateX(-110%);
      }
    }
  }
  .mantine-Carousel-viewport {
    width: calc(100% - 36px);
  }
  .mantine-Carousel-controls {
  }
`
